/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Error_Generator_UnavailableInputs */

const en_directory_ai_tools_error_generator_unavailable = /** @type {(inputs: Directory_Ai_Tools_Error_Generator_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The generator is temporarily unavailable. Please try again later.`)
};

const zh_directory_ai_tools_error_generator_unavailable = /** @type {(inputs: Directory_Ai_Tools_Error_Generator_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成器暂时不可用，请稍后再试。`)
};

/**
* | output |
* | --- |
* | "The generator is temporarily unavailable. Please try again later." |
*
* @param {Directory_Ai_Tools_Error_Generator_UnavailableInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_error_generator_unavailable = /** @type {((inputs?: Directory_Ai_Tools_Error_Generator_UnavailableInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Error_Generator_UnavailableInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_error_generator_unavailable(inputs)
	return zh_directory_ai_tools_error_generator_unavailable(inputs)
});
export { directory_ai_tools_error_generator_unavailable as "directory.ai_tools.error.generator_unavailable" }